import { ModelDefinitionsDataset } from 'ModelDefinitionsView/types';
export const MODEL_DEFINITIONS_DATASET_LOCAL_STORAGE_KEY = 'CGRPTL__ModelDefinitionsDataset';
export const MODEL_DEFINITIONS_DATASETS = Object.values(ModelDefinitionsDataset);
